export default __webpack_public_path__ + "04a21ce8218039e8a1ae3fce8837ecaa.jpg";